import React from 'react';
import styles from '../Home.module.css';

interface HomeErrorMessageProps {
  message: string;
}

const HomeErrorMessage: React.FC<HomeErrorMessageProps> = ({message}) => (
  <span className={styles.homeErrorMessage}>
    <svg
      className={styles.homeErrorIcon}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      data-testid="home-warning-icon"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 6v8m.05 4v.1h-.1V18z"
      />
    </svg>
    <span>{message}</span>
  </span>
);

export default HomeErrorMessage;
